<template>
    <b-modal ref="modal" title="量算吨位" no-close-on-backdrop ok-only ok-title="关闭"
             @ok="close()" @cancel="close()" @close="close()">
        <div v-if="areaHtml" class="mb-3 row">
            <div class="col-xl-4 text-right">面积：</div>
            <div class="col-xl-8" v-html="areaHtml"></div>
        </div>
        <b-card no-body>
            <b-tabs fill card>
                <b-tab title="实时数据" active>
                    <div v-if="realTime.error" class="mb-2 text-center text-danger">{{realTime.error}}</div>
                    <template v-else>
                        <div v-if="!realTime.info" class="text-center">量算中……</div>
                        <template v-else>
                            <div class="row" v-if="realTime.recommendWeight">
                                <div class="col-xl-5 text-right">推荐吨位：</div>
                                <div class="col-xl-6">{{realTime.recommendWeight}}吨以下</div>
                            </div>
                            <div class="row" v-for="item in realTime.info">
                                <div class="col-xl-5 text-right">{{item.title}}</div>
                                <div class="col-xl-3">{{item.count}}</div>
                                <div class="col-xl-3">{{item.percent}}</div>
                            </div>
                        </template>
                    </template>
                </b-tab>
                <b-tab title="历史数据">
                    <div v-if="history.error" class="mb-2 text-center text-danger">{{history.error}}</div>
                    <template v-else>
                        <div v-if="!history.info" class="text-center">量算中……</div>
                        <template v-else>
                            <div class="row" v-if="history.recommendWeight">
                                <div class="col-xl-5 text-right">推荐吨位：</div>
                                <div class="col-xl-6">{{history.recommendWeight}}吨以下</div>
                            </div>
                            <div class="row" v-for="item in history.info">
                                <div class="col-xl-5 text-right">{{item.title}}</div>
                                <div class="col-xl-3">{{item.count}}</div>
                                <div class="col-xl-3">{{item.percent}}</div>
                            </div>
                        </template>
                    </template>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-modal>
</template>

<script>
    import * as moment from 'moment';
    import {getArea} from 'ol/sphere';
    import {toLonLat} from '../olMap/coordUtils';
    import Plot from '../services/plot';

    const weightGroups = ["(0,500)", "[500,1000)", "[1000,1500)", "[1500,2000)", "[2000,2500)", "[2500,3000)"
        , "[3000,3500)", "[3500,4000)", "[4000,4500)", "[4500,5000)", "[5000,5500)", "[5500,6000)"
        , "[6000,10000)", "[10000,∞)"];

    export default {
        name: "MeasureWeightDialog",
        data() {
            return {
                areaHtml: "",
                realTime: {
                    error: null,
                    info: null,
                    recommendWeight: null,
                },
                history: {
                    error: null,
                    info: null,
                    recommendWeight: null,
                },
            };
        },
        methods: {
            modal(polygon, areaHtml) {
                this.areaHtml = areaHtml;
                this.realTime.error = this.history.error = null;
                this.realTime.info = this.history.info = null;
                this.area = getArea(polygon);
                let coordinates = polygon.getCoordinates()[0];
                this.lonLats = coordinates.map(x => toLonLat(x));
                this.doWeight();
                return new Promise(resolve => {
                    this.resolve = resolve;
                    this.$refs.modal.show();
                });
            },
            close() {
                this.resolve && this.resolve();
            },
            async doWeight() {
                if (this.area > 1000000000) {
                    this.realTime.error = this.history.error = "量算面积大于1千平方公里";
                } else {
                    await Promise.all([
                        this.doWeightType("realTime"),
                        this.doWeightType("history"),
                    ]);
                }
            },
            async doWeightType(type) {
                let result = await Plot.measureWeight(this.lonLats, type);
                if (result.error) {
                    this[type].error = result.error;
                } else {
                    let total = result.total || result.items.reduce((s, x) => s + x, 0);
                    this[type].recommendWeight = result.recommendWeight || null;
                    this[type].info = result.items.map((count, index) => ({
                        title: weightGroups[index] + "吨：",
                        count: count,
                        percent: total > 0 ? ((count * 100 / total).toFixed(2) + "%") : ""
                    }));
                }
            }
        },
    }
</script>

<style scoped>

</style>
